import { atom } from 'jotai';
import z from 'zod';

export const ZTemporaryCartKey = z.string();

export type TemporaryCartKeyAtom = z.infer<typeof ZTemporaryCartKey>;

/**
 * Temporary cart key atom for managing cart state during authentication flows.
 *
 * This atom stores a temporary cart key (UUID) that is used to:
 * - Synchronize cart state before and after user login
 * - Bridge guest cart to authenticated cart during email validation
 * - Persist cart contents across authentication challenges
 *
 * The key is cleared after successful cart migration to the authenticated session.
 */
export const temporaryCartKeyAtom = atom<TemporaryCartKeyAtom | undefined>(undefined);
